function ContactSection() {
  return (
    <div className="contact-container">
      <p>
        Github:{" "}
        <a
          href="https://github.com/bishalraitry"
          target="_blank"
          rel="noopener noreferrer"
        >
          bishalraitry
        </a>{" "}
      </p>
      <p>Email : bishalraicodes@gmail.com</p>
      <p>
        Dissertation:{" "}
        <a
          href="/documents/ST20253634_CST6000_WRIT1.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Investigating Generalisation in Reinforcement Learning (PDF)
        </a>
      </p>
    </div>
  );
}

export default ContactSection;

